module.exports = __webpack_public_path__ + "img/generalTroop.622f4644.png";